/**
 * Exemplos de problemas do Hub, mostrados no formulário de "novo problema".
 * Servem de referência do que faz sentido reportar aqui (falha/comportamento
 * inesperado do sistema) — e não de pedido de melhoria, que tem fila própria
 * em "Fila de Solicitações".
 */
interface ReportExample {
  title: string
  hint: string
}

export const REPORT_EXAMPLES: readonly ReportExample[] = [
  {
    title: 'Falha nas notificações aduaneiras',
    hint: 'A notificação não chegou, chegou duplicada ou com dados errados.',
  },
  {
    title: 'Problemas com a leitura/comparação de documentos',
    hint: 'A IA leu o PDF errado, não extraiu um campo ou acusou divergência inexistente.',
  },
  {
    title: 'CE não foi vinculado ao processo',
    hint: 'O CE/CCT existe no sistema mas não apareceu no processo.',
  },
  {
    title: 'Documento classificado com o tipo errado',
    hint: 'Ex.: uma invoice entrou como packing list.',
  },
  {
    title: 'Tracking do container não atualiza',
    hint: 'Sem novos eventos, ou eventos atrasados em relação ao armador.',
  },
  {
    title: 'LPCO não apareceu no processo',
    hint: 'Licença deferida no Portal Único que não refletiu no Hub.',
  },
  {
    title: 'Etapa do processo não avançou',
    hint: 'O status ficou parado mesmo com o evento já registrado.',
  },
  {
    title: 'Erro ao anexar ou baixar arquivo',
    hint: 'Upload falhando, download vazio ou anexo que sumiu.',
  },
  {
    title: 'Dados divergentes do sistema de origem',
    hint: 'Campo do processo diferente do que está no ERP/Portal.',
  },
  {
    title: 'Tela com erro ou em branco',
    hint: 'Descreva o caminho até a tela e o que apareceu.',
  },
] as const
